module.exports = __webpack_public_path__ + "img/truckFrontLeft.9bf25bc2.svg";